import type { ChangeEventHandler } from "react";
import { ReactNode } from "react";
import { Form } from "react-bootstrap";
import PlanFieldLabel from "../plan-field-label";
import styles from "./styles.module.scss";

type Props = {
  label: ReactNode;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  readOnly?: boolean;
  className?: string;
  controlId: string;
  placeholder: string;
  isTextArea?: boolean;
};
const SimpleTextFormGroup = ({
  controlId,
  label,
  value,
  onChange,
  readOnly,
  className,
  placeholder,
  isTextArea,
}: Props) => {
  return (
    <Form.Group className={className} controlId={controlId}>
      <PlanFieldLabel label={label} readOnly={readOnly} />
      {readOnly ? (
        <div className={styles["simple-text-form-group__input"]}>{value}</div>
      ) : (
        <Form.Control
          className={styles["simple-text-form-group__input"]}
          type="text"
          placeholder={placeholder}
          defaultValue={value || ""}
          onChange={onChange}
          readOnly={readOnly}
          plaintext={readOnly}
          {...(isTextArea && {
            rows: 1,
            as: "textarea",
          })}
        />
      )}
    </Form.Group>
  );
};

export default SimpleTextFormGroup;
